var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticStyle:{"padding":"24px 0"}},[_c('a-layout-content',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }